import { giphyPurple, giphyRed } from '@giphy/js-brand'
import { IGif } from '@giphy/js-types'
import React from 'react'
import { trending } from 'shared/api/videos'
import Observer from 'shared/components/observer'
import { useGifPaginator } from 'shared/hooks/use-gif-paginator'
import styled from 'styled-components'
import SectionHeader from '../../section-header'
import { MARGIN } from './constants'
import { ScrollCarousel, VideoPreview } from './sc'

const SeeAll = styled.div<{ width: number }>`
    position: relative;
    display: inline-block;
    vertical-align: top;
    color: white;
    font-weight: bold;
    background: linear-gradient(45deg, ${giphyPurple}, ${giphyRed});
    width: ${({ width }) => width}px;
    height: ${({ width }) => width - MARGIN}px;
    line-height: ${({ width }) => width - MARGIN}px;
    text-align: center;
    margin-left: ${MARGIN}px;

    a {
        text-decoration: none;
        border-bottom: none;
    }
`

type Props = {
    title?: string
    titleUrl?: string
    width: number
    className?: string
    hideAttribution?: boolean
    previewLabelPadding?: number
}

const TrendingVideoScrollCarousel = ({
    title = '',
    titleUrl = '',
    className = '',
    hideAttribution = false,
    previewLabelPadding = 0,
    width,
}: Props) => {
    const [gifs, fetchGifs] = useGifPaginator((offset: number) => trending({ offset }))
    return (
        <Observer onVisible={fetchGifs} fireOnce className={className}>
            {!!title && <SectionHeader label={title} url={titleUrl} />}
            <ScrollCarousel>
                {gifs.map((gif: IGif) => (
                    <VideoPreview
                        key={gif.id}
                        gif={gif}
                        width={width}
                        hideAttribution={hideAttribution}
                        labelPadding={previewLabelPadding}
                    />
                ))}
                {gifs.length > 0 && (
                    <SeeAll width={width}>
                        <a href="/videos">See All</a>
                    </SeeAll>
                )}
            </ScrollCarousel>
        </Observer>
    )
}

export default TrendingVideoScrollCarousel
